import { useState } from "react";
import { faqs } from "@/mocks/site";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section className="bg-background-50" aria-labelledby="faq-title">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-8 md:py-20">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-4">
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
              <i className="ri-question-line" />
              常见问题
            </span>
            <h2 id="faq-title" className="mt-5 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
              关于看料88，你可能想问
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              如果这里没有解答你的疑问，可以通过页脚的邮箱联系我们，工作日一般会在当天回复。
            </p>
          </div>

          <div className="lg:col-span-8">
            <div className="divide-y divide-background-200 border-y border-background-200">
              {faqs.map((faq, index) => {
                const isOpen = openIndex === index;
                return (
                  <div key={faq.q}>
                    <h3>
                      <button
                        type="button"
                        onClick={() => setOpenIndex(isOpen ? -1 : index)}
                        aria-expanded={isOpen}
                        className="flex w-full cursor-pointer items-center justify-between gap-4 py-5 text-left"
                      >
                        <span
                          className={`font-heading text-sm font-semibold transition-colors md:text-base ${
                            isOpen ? "text-primary-600" : "text-foreground-900"
                          }`}
                        >
                          {faq.q}
                        </span>
                        <span
                          className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                            isOpen ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                          }`}
                        >
                          <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                        </span>
                      </button>
                    </h3>
                    {isOpen && (
                      <div className="pb-5 pr-10">
                        <p className="text-sm leading-relaxed text-foreground-600">{faq.a}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}